import { createFetchReducer } from '../hooks/useFetchReduxed';
import { apiEvents, reducers } from '../features/pay/constants';
const payments = createFetchReducer(reducers.PENDING_PAYMENTS, apiEvents.pendingPayments[0], apiEvents.pendingPayments[1], apiEvents.pendingPayments[2], (payload) => {
    const { activities } = payload;
    return activities;
}, false);
export default payments;
